"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _grid = require("@rebass/grid");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LabelButton = _interopRequireDefault(require("../action/LabelButton"));
var _CircleView = _interopRequireDefault(require("../figure/CircleView"));
var _Play = _interopRequireDefault(require("../figure/Play"));
var VideoLabel = function VideoLabel(_ref) {
  var videoUrl = _ref.videoUrl,
    fullCircleImageUrl = _ref.fullCircleImageUrl;
  return videoUrl ? /*#__PURE__*/_react["default"].createElement(LabelContainer, null, /*#__PURE__*/_react["default"].createElement(_LabelButton["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_Play["default"], null),
    disabled: true
  }, "Video"), fullCircleImageUrl && /*#__PURE__*/_react["default"].createElement(_LabelButton["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_CircleView["default"], null),
    disabled: true,
    style: {
      marginLeft: '4px'
    }
  }, "360 \xB0")) : null;
};
var LabelContainer = (0, _styledComponents["default"])(_grid.Flex).withConfig({
  displayName: "VideoLabel__LabelContainer",
  componentId: "sc-1r80bec-0"
})(["position:absolute;right:", ";bottom:", ";z-index:1;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing['30_Small'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing['30_Small'];
});
var _default = exports["default"] = VideoLabel;
//# sourceMappingURL=VideoLabel.js.map